import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getVoucherType,
  getParticularPage,
  getNext,
  getPrevious,
  createVoucherType,
  updateVoucherType,
  handleSearch,
} from "./thunk";

const initialState = {
  voucherTypes: [],
  edit: false,
  voucherType: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingVoucherType: false,
  loadingNext: false,
  showCreateModal: false,
};

export const voucherTypeSlice = createSlice({
  name: "voucherType",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    voucherTypeEditSuccess: (state, action) => {
      state.edit = true;
      state.voucherType = state.voucherTypes.find((voucherType) => voucherType.id === action.payload);
    },
    clearAllVoucherType: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingVoucherType = false;
      state.voucherType = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createVoucherType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createVoucherType.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createVoucherType.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateVoucherType.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateVoucherType.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateVoucherType.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getVoucherType.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingVoucherType = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getVoucherType.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingVoucherType = false;
        state.voucherTypes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getVoucherType.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingVoucherType = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, voucherTypeEditSuccess, clearAllVoucherType } = voucherTypeSlice.actions;

export default voucherTypeSlice.reducer;
